(function () {
    "use strict";

    angular.module("app.cart").controller("CartController", CartController);

    CartController.$inject = [
        "$timeout",
        "$q",
        "$cookies",
        "CartService",
        "ProductService",
        "GeneralService",
        "SearchService",
        "SharedData",
        "$window",
        "$scope",
    ];

    function CartController(
        $timeout,
        $q,
        $cookies,
        CartService,
        ProductService,
        GeneralService,
        SearchService,
        SharedData,
        $window,
        $scope
    ) {
        /* jshint validthis:true */
        var vm = this;
        vm.optionList = [];
        vm.show = false;
        vm.loading = false;
        vm.showList = true;
        vm.SharedData = SharedData;
        vm.cartAddedHistory = [];
        vm.cartPageCss = "col-md-9";
        vm.criteoAccountCode = $window.CriteoAccountCode;
        vm.belowMinPriceValue = true;
        vm.lowestMinPriceList = [];
        vm.lowestMinPrice = 0;
        vm.checkButton = false;
        vm.cartIsEmpty = false;
        vm.userCartVisibility = false;
        vm.itemToDelete;
        vm.goCheckoutButtonLoader = false;

        function activate() {
            vm.loading = false;
            $timeout(function () {
                vm.getCart();
                if (vm.showFavorite) {
                    vm.getCart("Favorite");
                }
                if (vm.showLastView) {
                    vm.getLastViewProducts();
                }
                if (vm.showLastAdded) {
                    vm.cartAddedHistory = ($cookies.get("AddedHistory") || "")
                        .split(",")
                        .filter(function (item) {
                            return item !== "";
                        });
                    vm.getLastAddedProducts();
                }
            });
        }

        vm.activate = activate;

        vm.getLastViewProducts = function () {
            if (userId || getCookieByName("UserKey")) {
                SearchService.getLastViewProducts()
                    .then(function (response) {
                        vm.lastViewProducts = response;
                        $timeout(function () {
                            activateSliders(".lastview-product-list-slider");
                        }, 1000);
                    })
                    .catch(function () {});
            } else {
                vm.lastViewProducts = {};
            }
        };

        vm.getLastAddedProducts = function () {
            vm.showLastAdded = false;
            ProductService.getLastAddedProducts().then(function (response) {
                vm.lastAddedProducts = response;
                vm.showLastAdded = true;
                $timeout(function () {
                    if ("activateSliders" in $window) {
                        activateSliders(".releated-product-list-slider");
                    }
                }, 1000);
            });
        };

        vm.getCart = function (cartType) {
            vm.cartIsEmpty = false;
            var Id = $.Url.QueryString("Id", window.location.href);
            if (userId || getCookieByName("UserKey") || Id) {
                vm.loading = true;
                cartType = cartType || vm.cartType;
                return CartService.getCart({
                    Id: Id,
                    CartType: cartType,
                }).then(function (_cart) {
                    if (cartType === "Compare") {
                        vm.SharedData.Compare = _cart;
                        vm.prepareCompareOptions();
                    } else if (cartType === "Discount") {
                        vm.SharedData.Discount = _cart;
                    } else if (cartType === "Favorite") {
                        vm.SharedData.Favorite = _cart;
                        $timeout(function () {
                            activateSliders(".favorite-product-list-slider");
                        }, 1000);
                    } else {
                        vm.SharedData.Cart = _cart;
                        vm.cartIsEmpty = true;
                        angular
                            .element(".mobile-badge")
                            .text(vm.SharedData.Cart.CartProduct.length);

                        if (window.afterGetCart) {
                            window.afterGetCart();
                        }
                        if (vm.analytics) {
                            if (vm.criteoAccountCode)
                                $.Criteo.Basket(_cart, vm.criteoAccountCode);
                        }
                        vm.getCurrentShipmentProvider(vm.SharedData.Cart);
                    }
                    getBanks();
                    vm.show = true;
                    vm.loading = false;

                    ActivateCartRemoveEvent();
                });
            } else {
                vm.SharedData.Cart = {};
                vm.cartIsEmpty = true;
            }
        };

        vm.InsertWithParams = function (params) {
            vm.loading = true;

            if (vm.SharedData.Cart) {
                params.ShipmentProviderId =
                    vm.SharedData.Cart.ShipmentProviderId;
            }
            params.WarehouseId = params.WarehouseId
                ? params.WarehouseId
                : JSON.parse($window.localStorage["deliveryAddressIds"] || "{}")
                      .WarehouseId;

            return CartService.InsertWithParams(params).then(
                function () {
                    var cartType = params.AddCartType || params.CartType;
                    vm.getCart(cartType);
                    vm.loading = false;
                },
                function (params) {
                    vm.loading = false;
                    throw new Error(
                        params.data.Code + " : " + params.data.Message
                    );
                }
            );
        };

        vm.jsonParse = function (objString) {
            var result = "";
            if (objString) {
                if (typeof objString !== "string") {
                    return "";
                }
                result = JSON.parse(objString);
                if (typeof result === "string") {
                    return vm.jsonParse(result);
                }
            }
            return result;
        };

        vm.trimChar = function (string, charToRemove) {
            while (string.charAt(0) == charToRemove) {
                string = string.substring(1);
            }

            while (string.charAt(string.length - 1) == charToRemove) {
                string = string.substring(0, string.length - 1);
            }

            return string;
        };

        vm.InsertFindedProduct = function (ProductId, CartId, CartType) {
            vm.loading = true;
            var params = {
                productID: ProductId,
                quantity: 1,
                cartId: CartId,
            };
            if (CartType) {
                params.CartType = CartType;
            }
            CartService.InsertWithParams(params)
                .then(function () {
                    vm.searchProductKey = null;
                    vm.addChartProduct = false;
                    if (vm.showList) {
                        vm.showList = false;
                    }

                    if (params.AddCartType !== "cart") {
                        vm.getCart();
                    }
                })
                .catch(function (error) {
                    alert(error.data.Message);
                    window.location = "/Cart/Compare";
                });
        };

        vm.IsInCart = function (params) {
            return CartService.IsInCart(params).then(function (data) {
                return data;
            });
        };

        vm.Increment = function (cartProduct) {
            vm.loading = true;
            if (
                cartProduct.Quantity + cartProduct.Product.DefaultIncrement >
                cartProduct.Product.StockQuantity
            ) {
                vm.loading = false;
                alert("Yetersiz Stok");
                return;
            }
            CartService.Increment(cartProduct).then(function () {
                vm.getCart();
            });
        };

        vm.Decrement = function (cartProduct) {
            vm.loading = true;
            CartService.Decrement(cartProduct).then(function () {
                vm.getCart();
            });
        };

        vm.updateCartProduct = function (cartProduct) {
            vm.loading = true;
            CartService.Update(cartProduct).then(function () {
                vm.getCart();
            });
        };

        vm.Delete = function (cartProduct, cartType) {
            vm.loading = true;

            return CartService.Delete(cartProduct).then(function () {
                if (!cartType || cartType === "Cart") {
                    vm.addCartAddedHistory(cartProduct.Product.Code);
                } else {
                    vm.loading = false;
                }
                vm.getCart(cartType);
            });
        };

        vm.DeleteGroupProducts = function (groupedProducts) {
            vm.loading = true;
            for (var i = 0; i < groupedProducts.length; i++) {
                CartService.Delete(groupedProducts[i]).then(function () {});
            }
            vm.loading = false;
            vm.getCart("Cart");
        };
        vm.DeleteAll = function () {
            vm.loading = true;
            for (var i = 0; i < vm.SharedData.Cart.CartProduct.length; i++) {
                CartService.Delete(vm.SharedData.Cart.CartProduct[i]).then(
                    function () {}
                );
            }
            vm.loading = true;
            vm.getCart("Cart");
        };

        vm.addCartAddedHistory = function (value) {
            vm.cartAddedHistory;
            vm.cartAddedHistory.push(value);
            vm.cartAddedHistory = vm.cartAddedHistory.reverse().slice(0, 5);
            $cookies.put("AddedHistory", vm.cartAddedHistory);
            vm.getLastAddedProducts();
        };

        vm.totalPriceWithDiscount = function () {
            if (!vm.SharedData.Cart) {
                return 0;
            }
            return _.sumBy(vm.SharedData.Cart.CartProduct, function (o) {
                return o.TotalPriceWithDiscount;
            });
        };

        vm.totalGroupPrice = function (groupedProducts) {
            return groupedProducts.reduce(function (sum, value) {
                return sum + value.Product.Price * value.Quantity;
            }, 0);
        };

        vm.totalGroupPriceWithDiscount = function (groupedProducts) {
            return groupedProducts.reduce(function (sum, value) {
                return sum + value.Product.PriceWithDiscount * value.Quantity;
            }, 0);
        };

        vm.getMainImage = function (product) {
            var mainMedia;
            if (product.FirstImage) {
                return product.FirstImage;
            }
            if (product.ProductMedia) {
                mainMedia =
                    product.ProductMedia.find(function (media) {
                        return media.IsMain === true;
                    }) || product.ProductMedia[0];
            }
            if (mainMedia) {
                return mainMedia.Media.FullPath;
            } else {
                return "no-image.png";
            }
        };

        vm.prepareCompareOptions = function () {
            vm.optionList = [];
            $(vm.SharedData.Compare.CartProduct).each(function (
                i,
                cartProduct
            ) {
                $(cartProduct.Product.ProductOptionValue).each(function (
                    i,
                    productOptionValue
                ) {
                    var options = {
                        Id: productOptionValue.Option.Id,
                        Name: productOptionValue.Option.Name,
                        TopOptionName:
                            productOptionValue.Option.TopOption !== undefined
                                ? productOptionValue.Option.TopOption !== null
                                    ? productOptionValue.Option.TopOption.Name
                                    : "Genel"
                                : "Genel",
                        Values: [],
                        CustomValues: [],
                    };

                    vm.optionList.push(options);
                });
            });
            vm.optionList = vm.optionList.filter(function (value, index, self) {
                var item = self.find(function (item) {
                    return item.Name === value.Name;
                });
                return self.indexOf(item) === index;
            });
            $(vm.SharedData.Compare.CartProduct).each(function (
                i,
                cartProduct
            ) {
                $(cartProduct.Product.ProductOptionValue).each(function (
                    i,
                    productOptionValue
                ) {
                    var option = vm.optionList.find(function (opt) {
                        return opt.Id === productOptionValue.OptionId;
                    });
                    option.Values[cartProduct.Id] =
                        option.Values[cartProduct.Id] || {};
                    option.Values[cartProduct.Id].SubValues =
                        option.Values[cartProduct.Id].SubValues || [];
                    option.Values[cartProduct.Id].SubValues.push(
                        productOptionValue.OptionValue.Value
                    );
                    option.CustomValues.push(
                        productOptionValue.OptionValue.Value
                    );
                });
            });
            $(vm.optionList).each(function (i, option) {
                option.same = option.CustomValues.every(function (val, i, arr) {
                    return val === arr[0];
                });
            });
        };

        var searchTimeout;
        vm.searchProduct = function () {
            if (searchTimeout) $timeout.cancel(searchTimeout);
            vm.loadingProduct = true;
            vm.findProductList = [];
            searchTimeout = $timeout(function () {
                ProductService.searchProduct(vm.searchProductKey).then(
                    function (data) {
                        vm.findProductList = data;
                        vm.loadingProduct = true;
                        if (data) {
                            vm.showList = true;
                        }
                    }
                );
            }, 500);
        };

        vm.print = function (divName) {
            var printContents = document.getElementById(divName).innerHTML;
            var popupWin = window.open("", "_blank", "");
            popupWin.document.open();
            var printContent =
                "<html>" +
                '<body style="padding:5px;" onload="window.print()">' +
                printContents +
                "</body>" +
                '<link href="/dist/css/mazakacore-ecommerce-lib.css"  rel="stylesheet" />' +
                '<link href="/themes/' +
                window.themeName +
                '/dist/css/site.css"  rel="stylesheet" />' +
                '<script src="/dist/js/mazakacore-ecommerce-lib.js" ></script>' +
                '<script src="/dist/js/mazakacore-ecommerce-app.js" ></script>' +
                "</html>";
            popupWin.document.write(printContent);
            popupWin.document.close();
        };

        vm.IsAllProductInStock = function () {
            if (!vm.SharedData.Cart) {
                return false;
            }
            return !vm.SharedData.Cart.CartProduct.some(function (item) {
                return (
                    item.Product.TrackStockQuantity &&
                    item.Product.ClosedForSaleIfOutOfStock &&
                    item.Product.StockQuantity < item.Quantity
                );
            });
        };

        vm.clearAll = function (cartType) {
            vm.loading = true;
            var baseCart = null;
            if (cartType === "Compare") {
                baseCart = vm.SharedData.Compare;
            } else if (cartType === "Discount") {
                baseCart = vm.SharedData.Discount;
            } else if (cartType === "Favorite") {
                baseCart = vm.SharedData.Favorite;
            } else {
                baseCart = vm.SharedData.Cart;
            }
            var requests = [];
            for (var i = 0; i < baseCart.CartProduct.length; i++) {
                var cartProduct = baseCart.CartProduct[i];
                var result = CartService.Delete(cartProduct);
                ss;
                requests.push(result);
            }
            $q.all(requests).then(function () {
                vm.loading = false;
                vm.getCart();
            });
        };

        vm.goCheckout = function (fast) {
            vm.goCheckoutButtonLoader = true;
            if (!vm.checkButton) {
                vm.updateCart(vm.SharedData.Cart).then(function () {
                    var check = vm.checkCloseforsale();
                    if (check === false) {
                        var url =
                            "/Checkout/Checkout?cartId=" +
                            vm.SharedData.Cart.Id;
                        if (fast) {
                            url = url + "&fastBuy=true";
                        }
                        window.location = url;
                    } else {
                        alert(
                            "Sepetinizde satışa kapalı ya da pasif ürün bulunmaktadır.Bu ürünler boşaltılacaktır!"
                        );
                        vm.clearCloseforsale();
                    }
                });
            } else {
                vm.goCheckoutButtonLoader = false;
            }

            vm.checkButton = true;
        };

        vm.checkCloseforsale = function () {
            var returnVal = false;
            if (vm.SharedData.Cart.CartProduct.length > 0) {
                vm.SharedData.Cart.CartProduct.forEach((element) => {
                    if (
                        element.Product.ClosedForSale == true ||
                        element.Product.Active == false
                    )
                        returnVal = true;
                });
            } else {
                returnVal = true;
            }
            return returnVal;
        };

        vm.clearCloseforsale = function () {
            if (vm.SharedData.Cart.CartProduct.length > 0) {
                vm.SharedData.Cart.CartProduct.forEach((element) => {
                    if (
                        element.Product.ClosedForSale == true ||
                        element.Product.Active == false
                    )
                        CartService.Delete(element);
                });
            }
            vm.getCart();
            vm.checkButton = false;
        };

        vm.updateCart = function () {
            return CartService.updateCart(vm.SharedData.Cart).then(function (
                data
            ) {
                vm.loading = false;
                return vm.getCart();
            });
        };

        vm.googleDataLayer = function (data) {
            if (typeof $window.dataLayer !== undefined) {
                var analytics = JSON.parse(data.Product.AnalyticsData)
                    .products[0];
                $window.dataLayer.push({
                    event: "removeFromCart",
                    ecommerce: {
                        remove: {
                            products: [
                                {
                                    name: data.Name,
                                    id: data.Code,
                                    price: data.PriceWithDiscount,
                                    brand: analytics.brand,
                                    category: analytics.category,
                                    variant: analytics.variant,
                                    quantity: data.Quantity,
                                },
                            ],
                        },
                    },
                });
            }
        };

        vm.getCalculatePrice = function (product, discount) {
            var price = product.Price;
            var priceWithDiscount = product.PriceWithDiscount;
            var defaultPrice = product.Price;
            if (discount == 1) {
                defaultPrice = priceWithDiscount * product.Currency.Rate;
            } else if (discount == 0) {
                defaultPrice = price * product.Currency.Rate;
            } else if (discount == 2) {
                defaultPrice =
                    product.CurrentDiscount.Amount * product.Currency.Rate;
            }
            return defaultPrice;
        };

        function getCookieByName(name) {
            return $cookies.get(name);
        }

        $scope.$watch("vm.SharedData.Cart.TotalWithDiscount", function () {
            if ($window.formatter) {
                vm.SharedData.basketSummary = $window.formatter.format(
                    vm.SharedData.Cart.TotalWithDiscount || 0
                );
            }
        });

        $scope.$watch("vm.SharedData.Cart", function () {
            ActivateCartRemoveEvent();
        });

        vm.ApplyCouponCode = function (couponCode) {
            vm.loading = true;
            CartService.ApplyCoupon(couponCode)
                .then(function (data) {
                    vm.getCart().then(function () {
                        var eventListener = new SelectPromotionEventListener(
                            this
                        );
                        eventListener.callback(
                            vm.SharedData.Cart.CouponCode,
                            vm.SharedData.Cart.GeneralDiscountMessage
                        );
                    });
                    vm.loading = false;
                })
                .catch(function (error) {
                    vm.getCart();
                    alert(error.data.Message);
                    vm.loading = false;
                });
        };

        vm.RemoveCouponCode = function () {
            vm.loading = true;
            CartService.RemoveCoupon()
                .then(function (data) {
                    vm.cart.CouponCode = null;
                    vm.getCart();
                    vm.loading = false;
                })
                .catch(function (error) {
                    vm.getCart();
                    vm.loading = false;
                });
        };

        function getBanks() {
            GeneralService.GetBanks().then(function (data) {
                vm.banks = data.data.filter(function (item) {
                    return item.Active === true;
                });

                vm.checkoutBanks = vm.banks.filter(function (item) {
                    return item.UseCheckout;
                });
                vm.directCheckoutBanks = vm.checkoutBanks.filter(function (
                    item
                ) {
                    return item.ShowDirect;
                });
                vm.cartCheckoutBanks = vm.checkoutBanks.filter(function (item) {
                    return item.ShowCart;
                });

                vm.otherBanks = vm.banks.filter(function (item) {
                    return !item.UseCheckout;
                });
                vm.directOtherBanks = vm.otherBanks.filter(function (item) {
                    return item.ShowDirect;
                });
                vm.cartOtherBanks = vm.otherBanks.filter(function (item) {
                    return item.ShowCart;
                });

                vm.transferEFTBanks = data.data.filter(function (item) {
                    return item.TransferEFT && item.UseCheckout;
                });
                vm.defaultCheckoutBank = vm.banks.find(function (item) {
                    return item.Default;
                });
                vm.banks.forEach((bank) => {
                    if (
                        vm.SharedData.Cart.PaidTotalWithDiscount < bank.MinPrice
                    )
                        vm.belowMinPriceValue = false;
                    else {
                        vm.belowMinPriceValue = true;
                    }
                    vm.lowestMinPriceList.push(bank.MinPrice);
                    vm.lowestMinPrice = Math.min.apply(
                        Math,
                        vm.lowestMinPriceList
                    );
                });
            });
        }
        vm.userCartVisibilityToggle = function () {
            vm.userCartVisibility = !vm.userCartVisibility;
            $(".user-cart__shopping-cart").toggleClass("end-0");
            $(".user-cart__backdrop-shade").toggleClass("end-0 col-12 top-0");
        };
        vm.openDeletePopup = function (cartProduct) {
            $("#delete-cart-modal").modal("show");
            vm.itemToDelete = cartProduct;
            vm.loading = false;
        };
        vm.deleteAndAddFavorite = function (cartProduct, item) {
            $("#delete-cart-modal").modal("hide");
            var elem = angular.element(item.target);
            $.Cart.AddFavorite(elem, addFavoriteBoxCallback);
            vm.Delete(cartProduct);
        };
        vm.isSimple = function (product) {
            if (
                !product.SearchText.includes("ProductGroup=0") ||
                (product.SearchText.includes("O.") &&
                    product.SearchText.includes("V.") &&
                    !product.SearchText.includes("ProductVariant=0"))
            ) {
                return true;
            } else {
                return false;
            }
        };

        function ActivateCartRemoveEvent() {
            $(document).ready(function () {
                try {
                    var activateGtm = new ActivateGtm();
                    activateGtm.activateRemoveFromAllCart();
                    activateGtm.activateRemoveFromCart();
                } catch (error) {
                    console.log(error);
                }
            });
        }

        vm.getCurrentShipmentProvider = function (cart) {
            if (cart && cart.ShipmentProviderId) {
                GeneralService.getCurrentShipmentProvider(
                    cart.ShipmentProviderId
                ).then(function (response) {
                    if (response) {
                        cart.getCurrentShipmentProvider = response.data;
                    }
                });
            }
        };

        activate();
    }
})();
